export default "__VITE_ASSET__BP0$L3VO__"